import { useEffect, useState } from "react";
import { AiOutlineCar } from "react-icons/ai";
import Count from "../../../components/shared/Count";
import fetchDataArps from "../../../services/fetchDataArps";
import fetchVisitsAllIn from "../../../services/fetchVisistsAllIn";
import VehiclePanel from "./VehiclePanel";
export default function StayedWidget({ site_id }: any) {
  const [showDetails, setShowDetails] = useState(false);
  const [vehicles, setVehicles] = useState<any>([]);
  const [isLoading, setLoading] = useState(false);

  const [booking, setBooking] = useState<any[]>([])

  const operators: any = {
    " 113 ": "Samweli Kitomari",
    " 69 ": "Anna Mzori",
    " 5 ": "Fatuma Suleiman",
    " 104 ": "Noela Soka",
    " 6 ": "Anna Chaulo",
    " 27 ": "Diana Laizer",
    " 4 ": "Juliana Sendwa",
    " 48 ": "Consolata Begina",
    " 112 ": "Ruth Kulindwa",
    "0113": "Samweli Kitomari",
    "0069": "Anna Mzori",
    "0005": "Fatuma Suleiman",
    "0104": "Noela Soka",
    "0006": "Anna Chaulo",
    "0027": "Diana Laizer",
    "0004": "Juliana Sendwa",
    "0048": "Consolata Begina",
    "0112": "Ruth Kulindwa",
  };

  const getWips = async () => {
    const wipUrl = `wip/owner?start=${20220101}`
    const result = await fetchDataArps(wipUrl)
    setBooking(result)
  }

  const handleFetchVehicles = async () => {
    setLoading(true);
    const data = await fetchVisitsAllIn(site_id);
    const vehicleexists = await data.filter(
      (visit: any) => visit?.vehicle !== null
    );

    const filtered = await vehicleexists.filter(
      (visit: any) => visit?.timein !== visit?.timeout
    );

    getWips()

    setVehicles(filtered);
    setLoading(false);
  };

  const refetch = async () => {
    await handleFetchVehicles();
  };

  useEffect(() => {
    handleFetchVehicles();
  }, []);



  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-3 bg-white border border-gray-300 rounded-lg mx-2 hover:bg-red-100 cursor-pointer mb-2 sm:mb-0">
      <button
        onClick={() => setShowDetails(true)}
        className="py-2 px-3 flex flex-row items-center "
      >
        <div className="bg-blue-100 h-16 w-16 rounded-full text-white flex justify-center items-center">
          <AiOutlineCar size={35} color="#3257a8" />
        </div>
        <div className="flex flex-col ml-2 justify-center">
          <div className="text-xs text-blue-900 font-bold uppercase">
            Vehicles Stayed
          </div>
          <div className="flex  justify-between items-center text-sm">
            <div className="rounded-sm text-black text-3xl font-bold">
              <Count isLoading={isLoading} count={vehicles.length} />
            </div>
          </div>
        </div>
      </button>

      <VehiclePanel
        isVisible={showDetails}
        setShowDetails={setShowDetails}
        refetch={refetch}
        wips
        vehicles={vehicles}
        title={"Vehicles Stayed"}
      />
    </div>
  );
}
